import { NewsItem } from '@/entities/News';

export const categoryOptions = [
  { value: 'updates', label: 'Обновления' },
  { value: 'events', label: 'Мероприятия' },
  { value: 'important', label: 'Важное' },
  { value: 'useful_materials', label: 'Полезные материалы' },
];

export const categoryFilterOptions = [{ value: '', label: 'Все категории' }, ...categoryOptions];

export const statusFilterOptions = [
  { value: '', label: 'Все статусы' },
  { value: 'draft', label: 'Черновик' },
  { value: 'published', label: 'Опубликовано' },
];

export const roleFilterOptions = [
  { value: '', label: 'Все роли' },
  { value: 'player', label: 'Игрок' },
  { value: 'owner', label: 'Владелец' },
  { value: 'admin', label: 'Администратор' },
];

export const roleDetails = [
  { value: 'player', label: 'Игрок', pluralLabel: 'Игроки' },
  { value: 'owner', label: 'Владелец', pluralLabel: 'Владельцы' },
  { value: 'admin', label: 'Администратор', pluralLabel: 'Администраторы' },
];

export type PinnedRoleMap = Record<string, NewsItem | null>;

export const ALL_ROLES = ['player', 'owner', 'admin'] as const;

export const getEffectiveDate = (item: NewsItem): Date => new Date(item.publishedAt ?? item.updatedAt);

export const buildActivePinnedByRole = (newsList: NewsItem[]): PinnedRoleMap => {
  const now = new Date();
  const result: PinnedRoleMap = {};
  for (const role of ALL_ROLES) {
    const pinned = newsList.filter((n) => n.pinnedRoles?.includes(role));
    const sorted = [...pinned].sort((a, b) => getEffectiveDate(b).getTime() - getEffectiveDate(a).getTime());
    result[role] = sorted.find((n) => getEffectiveDate(n) <= now) ?? null;
  }
  return result;
};

export const collectStalePins = (
  newsList: NewsItem[],
  activeByRole: PinnedRoleMap,
): { id: number; pinnedRoles: string[] }[] => {
  const now = new Date();
  const staleMap: Record<number, Set<string>> = {};
  for (const news of newsList) {
    for (const role of news.pinnedRoles ?? []) {
      if (news.publishedAt && new Date(news.publishedAt) > now) continue;
      const active = activeByRole[role];
      if (active?.id === news.id) continue;
      if (!staleMap[news.id]) staleMap[news.id] = new Set(news.pinnedRoles);
      staleMap[news.id].delete(role);
    }
  }
  return Object.entries(staleMap).map(([newsId, roles]) => ({
    id: Number(newsId),
    pinnedRoles: Array.from(roles),
  }));
};
